// components
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

type AgeOfInventoryProps = {
    ageDays: number | null;
};

export const AgeOfInventory = ({ ageDays }: AgeOfInventoryProps) => {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            <Typography variant="body-md" color="sem.color.on-surface.muted" tag="span">
                Age of Inventory:
            </Typography>
            <Typography variant="body-md" tag="span">
                {typeof ageDays === 'number' ? `${ageDays} Days` : 'N/A'}
            </Typography>
        </Box>
    );
};
